import { useEffect, useRef } from 'react';
import { isFunction } from 'lodash';
import Platform from 'platform';
import keys from 'config/keys';
import { ACTION_TYPES } from './playerConstants';

const PLATFORM_KEYS = {
  PLAY: Platform.getKeyCode(keys.PLAY),
  PAUSE: Platform.getKeyCode(keys.PAUSE),
  RW: Platform.getKeyCode(keys.RW),
  FF: Platform.getKeyCode(keys.FF),
  STOP: Platform.getKeyCode(keys.STOP),
  BACK: Platform.getKeyCode(keys.BACK),
  RED: Platform.getKeyCode(keys.RED),
  YELLOW: Platform.getKeyCode(keys.YELLOW),
  BLUE: Platform.getKeyCode(keys.BLUE),
  GREEN: Platform.getKeyCode(keys.GREEN),
  CH_UP: Platform.getKeyCode(keys.CH_UP),
  CH_DOWN: Platform.getKeyCode(keys.CH_DOWN),
};

const ActionBykeyCode = {
  [PLATFORM_KEYS.PLAY]: ACTION_TYPES.PLAY,
  [PLATFORM_KEYS.PAUSE]: ACTION_TYPES.PAUSE,
  [PLATFORM_KEYS.RW]: ACTION_TYPES.RW,
  [PLATFORM_KEYS.FF]: ACTION_TYPES.FF,
  [PLATFORM_KEYS.STOP]: ACTION_TYPES.STOP,
  [PLATFORM_KEYS.CH_UP]: ACTION_TYPES.CH_UP,
  [PLATFORM_KEYS.CH_DOWN]: ACTION_TYPES.CH_DOWN,
};

type CBType = (action: keyof typeof ACTION_TYPES) => void;

const useOnKeydown = (cb: CBType) => {
  const callBackRef = useRef(cb);
  useEffect(() => {
    const onKeyDown = ({ keyCode }) => {
      const action = ActionBykeyCode[keyCode];
      const currCallback = callBackRef.current;

      if (action && isFunction(currCallback)) currCallback(action);
    };

    document.body.addEventListener('keydown', onKeyDown, true);

    return () => document.body.removeEventListener('keydown', onKeyDown, true);
  }, []);

  useEffect(() => {
    callBackRef.current = cb;
  }, [cb]);
};

export default useOnKeydown;
